export const getBoundingBox = (points: number[][]) => {
  // Handle empty points array
  if (!points.length) {
    return {
      x: 0,
      y: 0, 
      width: 0,
      height: 0
    };
  }

  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  points.forEach(([x, y]) => {
    if (x < minX) minX = x;
    if (y < minY) minY = y; 
    if (x > maxX) maxX = x;
    if (y > maxY) maxY = y;
  });

  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
};
export function rotate(cx: number, cy: number, x: number, y: number, angle: number) {
  var radians = (Math.PI / 180) * angle,
      cos = Math.cos(radians),
      sin = Math.sin(radians), 
      nx = (cos * (x - cx)) + (sin * (y - cy)) + cx,
      ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
  return [nx, ny];
}
export const getCenterOfPolygon = (points: number[][]) => {
  var area = 0;
  var x = 0;
  var y = 0;
  
  for (var i = 0; i < points.length - 1; i++) {
    var temp = (points[i][0] * points[i + 1][1]) - (points[i + 1][0] * points[i][1]);
    
    area += temp;
    x += (points[i][0] + points[i + 1][0]) * temp;
    y += (points[i][1] + points[i + 1][1]) * temp;
  }
  
  area *= 0.5;
  x /= 6 * area;
  y /= 6 * area;
  
  return { x, y };
}
export const getPolygonDimension = (points: number[]) => {
  var minX = Math.min(...points.filter((_, i) => i % 2 === 0));
  var maxX = Math.max(...points.filter((_, i) => i % 2 === 0));
  var minY = Math.min(...points.filter((_, i) => i % 2 === 1));
  var maxY = Math.max(...points.filter((_, i) => i % 2 === 1));

  var width = maxX - minX;
  var height = maxY - minY;
  return { width, height }
}
const rotatePoint = (x: number, y: number, cx: number, cy: number, angle: number) => {
  const radians = (angle * Math.PI) / 180;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  
  // Translate point to origin
  const dx = x - cx;
  const dy = y - cy;
  
  // Rotate point
  const rotatedX = dx * cos - dy * sin + cx;
  const rotatedY = dx * sin + dy * cos + cy;
  
  return [rotatedX, rotatedY ];
};
export const rotateBox = (
  box: { x: number, y: number, width: number, height: number }, 
  angle: number,
  center: { x: number, y: number }
) => {
  // Get all 4 corners
  const corners = [
    [box.x, box.y],                           // top-left
    [box.x + box.width, box.y],               // top-right
    [box.x + box.width, box.y + box.height],  // bottom-right
    [box.x, box.y + box.height]               // bottom-left
  ];
  
  // Rotate each corner around the provided center point
  const rotatedCorners = corners.map(([x, y]) => 
    rotate(center.x, center.y, x, y, angle)
  );
  
  // Calculate new bounding box from rotated points
  return getBoundingBox(rotatedCorners);
};
